import safeLog from '@alife/bc-safe-log';

const $ = require('@alife/alpha-jquery/jquery');
const Xman = require('../sku-attrs/old/src/common/xman/xman');

const getSample = {
  init(config) {
    const that = this;
    that.config = config;
    if (
      !that.config ||
      that.config.productSamplingTotalPrice === '' ||
      that.config.productSamplingOrderQuantity === '' ||
      that.config.productId === ''
    ) {
      return false;
    }
    $('#J-btn-get-sample').click(e => {
      e.preventDefault();
      Xman(gXman => {
        const xman = new gXman.Popup({});
        if (xman.isLoggedIn()) {
          safeLog(
            '/sc.details.getSample',
            'CLK',
            'from=wsaction&result=success&alreadylogin',
            'GET',
          );
          that.getSample();
        } else {
          xman.show();
          xman.on('LOGIN_SUCCESS', () => {
            safeLog(
              '/sc.details.getSample',
              'CLK',
              'from=wsaction&result=success&needlogin',
              'GET',
            );
            that.getSample();
          });
        }
      });
    });
  },
  getSample() {
    const dispatchLocation = $('#placeOfDispatches').val() || 'CN';
    let skuParam = '';
    if ($('.sample-attr').length) {
      skuParam = `,"skuId":"${$('.sample-attr').data('sku-id')}"`;
    }
    window.open(
      `${window.location.protocol}//biz.alibaba.com/contract/SampleOrder.htm?data=[{"productId":${this.config.productId},"dispatchLocation":"${dispatchLocation}"${skuParam}}]&tracelog=from_detail_get_sample`,
    );
  },
};

module.exports = getSample;
